import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getAuth } from 'firebase/auth';

export const useAdminRole = () => {
  const { currentUser } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminRole = async () => {
      if (!currentUser) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const token = await currentUser.getIdTokenResult();
        setIsAdmin(!!token.claims.admin);
      } catch (error) {
        console.error('Erreur lors de la vérification du rôle admin:', error);
        setIsAdmin(false);
      }
      
      setLoading(false);
    };

    checkAdminRole();
  }, [currentUser]);

  return { isAdmin, loading };
};
